// removed by extract-text-webpack-plugin
module.exports = {"changeEmail":"changeEmail___3Ee5H"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ChangeUserProfile.module.less
// module id = 744
// module chunks = 0